import { Component } from '@angular/core';
import { CreateTenderModel } from "../../../models/inModels/Tender";
import { TenderService } from "../../../services/business/tender.service";
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { BusinessService } from "../../../services/business/business-category.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { StorageService } from "../../../services/system/storage.service";

@Component({
	selector: 'app-tenders-create',
	templateUrl: './tenders-create.component.html',
	styleUrls: ['./tenders-create.component.css']
})
export class TendersCreateComponent {
	model: CreateTenderModel;
	loading = false;
	error: Message[];
	messages: Message[];
	categories: SelectItem[];
	provinces: SelectItem[];
	selectedCategory;
	selectedProvince;
	uploading = false;
	tenders;
	selectedTenderType;
	constructor(
		private storageService: StorageService,
		private auth: AuthenticationService,
		private router: Router,
		private service: TenderService,
		private businessService: BusinessService) {
		this.model = new CreateTenderModel();
		this.model.Push = true;
		this.model.Email = true;
	}

	initCategoryDropDown(event) {
		this.businessService.getDropdown(event).then(
			x => {
				this.categories = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setCategory(): void {
		this.model.businessCategoryId = this.selectedCategory.value;
	}

	initProvinceDropDown(event) {
		this.service.getProvinceDropdown(event).then(
			x => {
				this.provinces = x ;
			},
			error => {
				this.error = [];
				this.error.push({severity: 'error', summary: 'Error', detail: error})
			}
		)
	}

	setProvince(): void{
		this.model.provinceId = this.selectedProvince.value;
	}
	goBack(): void {
		this.router.navigate(['/tenders']);
	}
	handleFile(event, property): void {
		var result = this.storageService.handleSuccess(event);
		console.log(result);
		this.model[property] = result.PublicId;
		this.uploading = false;
	}

	handleError(event): void {
		this.uploading = false;
		this.messages = [];
		this.storageService.handleError(event, this.messages);
	}

	viewDocument(property): void {
		window.open(`${this.storageService.viewUrl}/${this.model[property]}`, '_blank');
	}

	removeDocument(property): void {
		this.model[property] = null;
		this.uploading = false;
	}

	save() {
		console.log(this.model);
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initTenderTypeDropDown(event): void {
		this.service.getTenderTypeDropdownList(event).then(
			x => {
				this.tenders = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setTenderType(): void {
		this.model.tenderTypeId = this.selectedTenderType.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/tenders/tenders-create/tenders-create.component.ts